import { createContext } from 'react'

import { DEFAULT_LANGUAGE } from './constants'
import { TContextProps } from './models/typesDefinition'

export const LanguageContext = createContext<TContextProps>({
  t: (key: string) => key,
  setLanguage: () => {},
  language: DEFAULT_LANGUAGE,
  translationIsLoading: false,
  isLanguageScopeLoading: {},
  removeScope: () => {},
  initScope: (scope: string) => Promise.resolve(),
})
